import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import { KINDS, kindLabel, storyDate, clubName, loadStories, chronological } from './common';
import { t, tt, route, find, syncLocale } from '../../i18n';

/**
 * /dark-pages — overzicht van alle zware verhalen, chronologisch per jaar, met filters op soort en zoeken.
 */
export default class DarkPagesPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    syncLocale();

    this.loading = true;
    this.stories = [];
    this.query = '';
    this.kind = '';

    app.history.push('lc.dark', 'The Dark Pages');
    app.setTitle('The Dark Pages');
    app.setTitleCount(0);

    loadStories().then((stories) => {
      this.stories = chronological(stories);
      this.loading = false;
      m.redraw();
    });
    if (app.store.all('lc-clubs').length < 20) find('lc-clubs').then(() => m.redraw());
  }

  view() {
    const list = this.filter(this.stories);
    const kinds = KINDS.filter((k) => this.stories.some((s) => s.kind() === k));

    return (
      <div className="LcDark">
        <section className="LcDark-hero">
          <div className="container">
            <p className="LcDark-eyebrow">{t('dark.eyebrow')}</p>
            <h1 className="LcDark-title">The Dark Pages</h1>
            <p className="LcDark-lead">{t('dark.lead')}</p>
            <p className="LcDark-warning">
              <i className="fas fa-exclamation-triangle" aria-hidden="true" /> {t('dark.warning')}
            </p>
          </div>
        </section>

        <section className="container LcDark-index">
          <div className="LcDark-filters">
            <div className="LcDark-search">
              <i className="fas fa-search" aria-hidden="true" />
              <input
                type="search"
                className="FormControl"
                placeholder={tt('dark.search_placeholder')}
                value={this.query}
                oninput={(e) => (this.query = e.target.value)}
                aria-label={tt('dark.search_label')}
              />
            </div>
            <div className="LcDark-kinds" role="group" aria-label={tt('dark.kinds_label')}>
              <button className={'LcDark-kind' + (!this.kind ? ' is-active' : '')} onclick={() => (this.kind = '')} aria-pressed={!this.kind ? 'true' : 'false'}>
                {t('dark.all')}
              </button>
              {kinds.map((k) => (
                <button
                  className={'LcDark-kind' + (this.kind === k ? ' is-active' : '')}
                  onclick={() => (this.kind = this.kind === k ? '' : k)}
                  aria-pressed={this.kind === k ? 'true' : 'false'}
                >
                  {kindLabel(k)}
                </button>
              ))}
            </div>
          </div>

          {this.loading ? (
            <LoadingIndicator />
          ) : list.length ? (
            this.years(list)
          ) : (
            <p className="LcDark-empty">{this.stories.length ? t('dark.no_results') : t('dark.empty')}</p>
          )}
        </section>
      </div>
    );
  }

  /** Verhalen gegroepeerd per jaar, als één doorlopende tijdlijn. */
  years(list) {
    const groups = [];
    list.forEach((s) => {
      const y = s.year() || '—';
      if (!groups.length || groups[groups.length - 1].year !== y) groups.push({ year: y, items: [] });
      groups[groups.length - 1].items.push(s);
    });

    return (
      <ol className="LcDark-years">
        {groups.map((g) => (
          <li className="LcDark-year" key={g.year}>
            <h2 className="LcDark-yearLabel">{g.year}</h2>
            <ul className="LcDark-entries">{g.items.map((s) => this.entry(s))}</ul>
          </li>
        ))}
      </ol>
    );
  }

  entry(story) {
    const clubs = (story.clubSlugs() || []).map(clubName).filter(Boolean);
    return (
      <li key={story.slug()} className={'LcDark-entry' + (story.weight() >= 4 ? ' is-major' : '')}>
        <Link href={route('lc.dark.story', { slug: story.slug() })}>
          <span className="LcDark-meta">
            {story.isPublished() ? null : <span className="LcDark-draft">{t('dark.draft')}</span>}
            <span className={'LcDark-tag LcDark-tag--' + story.kind()}>{kindLabel(story.kind())}</span>
            <span>{storyDate(story)}</span>
            {clubs.length ? <span>{clubs.join(', ')}</span> : story.place() ? <span>{story.place()}</span> : null}
          </span>
          <h3 className="LcDark-entryTitle">{story.title()}</h3>
          {story.summary() ? <p className="LcDark-entrySummary">{story.summary()}</p> : null}
        </Link>
      </li>
    );
  }

  filter(stories) {
    const q = this.query.trim().toLowerCase();
    return stories.filter((s) => {
      if (this.kind && s.kind() !== this.kind) return false;
      if (!q) return true;
      const clubs = (s.clubSlugs() || []).map(clubName).filter(Boolean).join(' ').toLowerCase();
      return s.searchText().includes(q) || clubs.includes(q);
    });
  }
}
